var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-stub"},[_c('h2',{staticClass:"the-stub-headline"},[_vm._v(" Пока нет статей ")]),_c('p',{staticClass:"the-stub-text mb-16px"},[_vm._v(" Создайте свою первую категорию и добавьте в неё статьи. ")]),_c('base-action-button',{attrs:{"text":"Создать категорию","is-add-button":true},on:{"onButtonClicked":_vm.onOpenModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }